import { withRouter } from "react-router-dom";
import styled, { css, keyframes } from "styled-components";
import { withTheme } from "@material-ui/core/styles";
import position from "./position";
import focus from "./focus";
import focusShifted from "./focusShifted";

const blast = keyframes`
  0% {
     transform:scale(1.0);
     opacity: 1;
     border-width: 2rem;
  }
  50% {
    transform:scale(2.5);
    opacity: 0;
    border-width: 0rem;
  }
`;

const OuterRings = styled.div`
  ${position}
  ${({ theme }) => css`
    border-color: ${theme.palette.secondary.main};
  `}
  ${({ open, location: { pathname } }) =>
    pathname === "/" &&
    css`
      ${focus}
      ${open && focusShifted}
      ${({ theme }) => [theme.breakpoints.up("lg")]} {
        ${focusShifted}
      }
    `};
  border-width: 0;
  border-style: solid;
  animation: ${blast} 6s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  animation-delay: ${({ delay }) => delay + 8}s;
`;

export default withRouter(withTheme(OuterRings));
